<template>
  <v-dialog v-model="dialog.show" :width="dialog.width" :persistent="dialog.isPersistent" :max-width="dialog.width" @click:outside="closeModal">
    <v-card>
      <v-card-title>
        <span class="headline"><lang :t="dialog.title"></lang></span>
      </v-card-title>

      <!-- EDIT TRAY -->
      <template v-if="dialog.type == 'editTray' && editedItem != null">
        <v-card-text>
          <lang :t="'ARTICLE-BUNDLE-TRAY-' + editedItem.name.toUpperCase()" />

          <v-select :items="editedItem.options" v-model="editedItem.value" :disabled="editedItem.clear" />

          <v-switch v-model="editedItem.clear" color="themeColor" hide-details>
            <template v-slot:label>
              <lang t="ATTRIBUTE-OVERRIDE-RESET" />
            </template>
          </v-switch>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal" :disabled="dialog.isSaving"><lang t="GLOBAL-BTN-CANCEL"></lang></v-btn>

          <v-btn elevation="0" light rounded color="themeColor" :loading="dialog.isSaving" @click="changeTray()">
            <lang t="GLOBAL-BTN-SET"></lang>
          </v-btn>
        </v-card-actions>
      </template>

      <!-- SURFACE INFORMATION -->
      <template v-else-if="dialog.type == 'surfaceInfo'">
        <v-card-text>
          <div v-if="surfaceInfoResult == null || surfaceInfoResult.isLoading" style="display: flex; align-items; center; justify-content: center;">
            <v-progress-circular size="48" width="4" indeterminate color="themeColor"></v-progress-circular>
          </div>

          <template v-else>
            <template v-if="!surfaceInfoResult.isLoading && surfaceInfoResult.result.error">
              {{ surfaceInfoResult.result.error }}
            </template>

            <template v-else>
              <rules-editor
                :calculation="surfaceInfoResult.result"
                :testResult="surfaceInfoResult.result"
                :ruleSettings="surfaceInfoResult.settings"
                :constants="surfaceInfoResult.constants"
                mode="testing"
              />
            </template>
          </template>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal()"><lang t="GLOBAL-BTN-CLOSE"/></v-btn>
        </v-card-actions>
      </template>

            <!-- DIAGRAM -->
      <template v-else-if="dialog.type == 'charts'">
        <v-card-text>
          <v-tabs v-model="chartActiveTab" background-color="transparent" color="black" slider-color="themeColor" light slider-size="3">
            <v-tab><lang t="BUNDLE-STATS-DIMENSIONS_VARIANCES"></lang></v-tab>
            <v-tab><lang t="BUNDLE-DIMENSION-HISTOGRAM"></lang></v-tab>
        </v-tabs>
        <v-tabs-items v-model="chartActiveTab" v-if="!isLoading">
          <v-tab-item class="pa-6">
            <bundle-chart :show="dialog.show" :bundleId="bundle.id"></bundle-chart>
          </v-tab-item>
          <v-tab-item class="pa-6">
            <historyBundleChart :show="dialog.show" :bundle="bundle"></historyBundleChart>
          </v-tab-item>
        </v-tabs-items>
         
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal()">
            <lang t="GLOBAL-BTN-CLOSE" />
          </v-btn>
        </v-card-actions>
      </template>

      <!-- DIAGRAM -->
      <template v-else-if="dialog.type == 'chart'">
        <v-card-text>
          <bundle-chart :show="dialog.show" :bundleId="bundle.id"></bundle-chart>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal()">
            <lang t="GLOBAL-BTN-CLOSE" />
          </v-btn>
        </v-card-actions>
      </template>


      <!-- HISTORY DIAGRAM -->
      <template v-else-if="dialog.type == 'history-chart'">
        <v-card-text>
          <historyBundleChart :show="dialog.show" :bundle="bundle"></historyBundleChart>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal()">
            <lang t="GLOBAL-BTN-CLOSE" />
          </v-btn>
        </v-card-actions>
      </template>

      <template v-else>
        <!-- CONDITION -->
        <v-card-text v-if="editedItem != null">
          <lang :t="'ARTICLE-BUNDLE-ATTRIBUTE-' + editedItem.name.toUpperCase()" />

          <template v-if="editedItem.type == 'enum'">
            <v-select :items="editedItem.settings.options" v-model="editedItem.pivot.override" :disabled="editedItem.pivot.clear" />
          </template>

          <template v-else-if="editedItem.type == 'string'">
            <v-text-field v-model="editedItem.pivot.override" :disabled="editedItem.pivot.clear" />
          </template>

          <template v-else-if="editedItem.type == 'number'">
            <v-text-field type="number" v-model="editedItem.pivot.override" :disabled="editedItem.pivot.clear" />
          </template>

          <template v-else-if="editedItem.type == 'boolean'">
            <v-switch v-model="editedItem.pivot.override" color="themeColor" hide-details :disabled="editedItem.pivot.clear"></v-switch>
          </template>

          <v-switch v-model="editedItem.pivot.clear" color="themeColor" hide-details>
            <template v-slot:label>
              <lang t="ATTRIBUTE-OVERRIDE-RESET" />
            </template>
          </v-switch>

          <!--  Wenn der Override-Wert "RUNPICK" gewählt wird (und der Originalwert nicht RUNPICK ist) -->
          <!-- special handling for PRODUCTION LINE -->
          <template v-if="editedItem.name == 'productionline' && editedItem.pivot.override == 'RUNPICK' && bundle.productionLine != 'RUNPICK'">
            <v-alert type="warning" dense class="mt-4"><lang t="BUNDLE_OVERRIDE_PRODUCTIONLINE_WARNING"/></v-alert>
          </template>
        </v-card-text>

        <!-- DIALOG ACTIONS -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal" :disabled="dialog.isSaving"><lang t="GLOBAL-BTN-CANCEL"></lang></v-btn>

          <v-btn elevation="0" light rounded color="themeColor" :loading="dialog.isSaving" @click="changeAttribute()">
            <lang t="GLOBAL-BTN-SET"></lang>
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import RulesEditor from "@/views/settings/derivationRules/RulesEditor";
import bundleChart from "@/views/items/item-bundle-chart";
import historyBundleChart from "@/views/items/item-history-bundle-chart";
import { cloneDeep } from "lodash";
import { converterMixin } from "../../mixins/converterMixin";

export default {
  name: "Dialog",
  mixins:[converterMixin],
  components: {
    RulesEditor,
    bundleChart,
    historyBundleChart
  },
  props: {
    dialogSettings: {
      type: Object,
    },
    itemEdited: {
      type: Object,
      default: null,
    },
    propBundle: {
      type: Object,
    },
    surfaceInfoResultSettings: {
      type: Object,
    },
  },
  data() {
    return {
      chartActiveTab: 0,
      dialog: {
        show: false,
        width: "640px",
        title: "",
        type: null,
        isLoading: false,
        isSaving: false,
        isPersistent: true,
      },
      editedItem: null,
      bundle: null,
      surfaceInfoResult: null,
    };
  },
  watch: {
    dialogSettings: {
      handler() {
        this.dialog = Object.assign(this.dialog, { ...this.dialogSettings });
      },
      deep: true,
    },
    itemEdited: {
      handler() {
        let item = cloneDeep(this.itemEdited)
        if(item.pivot.override && !this.isMetricUnitSystem){
          item = this.convertItemAttributeToImperialByBundle(item, cloneDeep(this.propBundle));
        }
        this.editedItem = item;
      },
      deep: true,
    },
    propBundle:{
      handler(){
        this.bundle = cloneDeep(this.propBundle);
      },
      deep: true,
      immediate: true,
    },
    surfaceInfoResultSettings: {
      handler() {
        this.surfaceInfoResult = cloneDeep(this.surfaceInfoResultSettings);
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    changeTray(){
      this.$emit('changeTray', this.editedItem);
    },
    changeAttribute() {
      let item = cloneDeep(this.editedItem);
      if(!this.isMetricUnitSystem && item.pivot.override){
        item = this.convertItemAttributeToMetricByBundle(item,cloneDeep(this.propBundle));
      }
      this.$emit('changeAttribute', item);
    }, 
    closeModal() {
      this.dialog = Object.assign(this.dialog, { show: false, isLoading: false });
      this.surfaceInfoResult = null;
      this.currentAttribute = null;
      this.editItem = null;

      this.$emit("closeModal", cloneDeep(this.dialog));
    },
  },
};
</script>

<style lang="scss" scoped></style>
